module.exports = __webpack_public_path__ + "static/media/storytelling-2@2x.07730925.png";